import * as actionType from './../constants/ActionTypes';
import Components from '../../../constants/Components';
import Logger from 'neon-frontend-utils/src/logger';

const initialState = {
    reports: null
};

/**
 * Returns the new state
 * @param {Object} state - state
 * @param {Object} action - action
 * @returns {Object} new state
 */
export default function reportsReducer(state = initialState, action) {
    const newState = Object.assign({}, state);

    switch (action.type) {
        case actionType.GET_REPORTS:

            try {
                newState.reports = action.response;
            } catch (error) {
                Logger.instance.error({
                    message: 'Exception in Reports reducer GET_REPORTS',
                    component: Components.REPORTS,
                    error
                });
            }

            break;

        default:
            return state;
    }
    return newState;
}
